import { Box, Typography } from "@mui/material";
import SvgToIcon from "../../../../../../icons/SvgToIcon";
import { DataStoreResourceType } from "../../../../../../utils/constants";
import { icons, logos } from "../../../icons/iconExport";
import { DataStoreResourceTypeIconsAndLabels } from "../../../utils";
import TextIntegrationStyle from "../../TextIntegrationStyle";

export default function CheckmarxRepositoryDetailsView({ entityData }) {
  const checkmarx_data = entityData?.checkmarx_data;

  if (!checkmarx_data) return null;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      {/* Resource Type */}
      {entityData?.resource_type && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.serverTypeIcon} width="16px" />
            <Typography variant="subtitle2">Resource Type</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={logos.CheckmarxLogo} width="16px" />
            <TextIntegrationStyle
              title=""
              value={
                DataStoreResourceTypeIconsAndLabels[
                  DataStoreResourceType.REPOSITORY
                ][1]
              }
            />
          </Box>
        </Box>
      )}
      {/* Repository URL */}
      {checkmarx_data.repo_url && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.LinkIcon} width="16px" />
            <Typography variant="subtitle2">Repository URL</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={checkmarx_data.repo_url}
              onClick={() => window.open(checkmarx_data.repo_url, "_blank")}
              style={{ cursor: "pointer", textDecoration: "underline" }}
            />
          </Box>
        </Box>
      )}

      {/* Scanned files */}
      {checkmarx_data.scanned_files !== undefined && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.FileCodeIcon} width="16px" />
            <Typography variant="subtitle2">Scanned Files</Typography>
          </Box>
          <Box ml={2} display="flex" alignItems="center" gap={2}>
            <TextIntegrationStyle
              title=""
              value={checkmarx_data.scanned_files}
            />
          </Box>
        </Box>
      )}

      {/* Unscanned files */}
      {checkmarx_data.unscanned_files !== undefined && (
        <Box display="flex" flexDirection="column" gap={1}>
          <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
            <SvgToIcon IconLogo={icons.FileCodeIcon} width="16px" />
            <Typography variant="subtitle2">Unscanned Files</Typography>
          </Box>
          <Box ml={2} display="flex">
            <TextIntegrationStyle
              title=""
              value={checkmarx_data.unscanned_files}
            />
          </Box>
        </Box>
      )}
    </Box>
  );
}
